export function stopAllTimers() {
  if (typeof window === "undefined") {
    return;
  }

  const maxTimerId = window.setTimeout(function() {}, 0);
  for (let timerId = 0; timerId <= maxTimerId; timerId += 1) {
    window.clearTimeout(timerId);
    window.clearInterval(timerId);
  }
}

export function goLoginAfterPasswordChange() {
  if (typeof window === "undefined") {
    return;
  }

  window.sessionStorage.setItem("login", "");
  stopAllTimers();
  window.location.href = "/index";
}
